import { render, staticRenderFns } from "./edit-decoration-policy-form.vue?vue&type=template&id=7ace0642&scoped=true&"
import script from "./edit-decoration-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-decoration-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ace0642",
  null
  
)

export default component.exports